import React from 'react'
import {Link} from 'react-router-dom'
import './style.css'

export default function navbarpopup() {
    return (
        <div className="navbar-icon-popup">
            <div className="header-keranjang">
                <h3>Keranjang Anda</h3>
                <Link to="cart_page">Lihat Selengkapnya</Link>
            </div>
           {
               DataContents.map((item, i) => {
                   return (
                    <Link to="#" key={i} className="content-keranjang">
                        <img src={item.img} alt="keranjang" />
                        <div className="name-content">
                            <p>{item.text}</p>
                            <small>{item.small}</small>
                        </div>
                        <p className="price">{item.price}</p>
                    </Link>
                   )
               })
           }
        </div>
    )
}

const DataContents = [
    {img:"asset/dashboard/produk/img-4.png", text:"Kurma Sukaria Al Qosim ...", small:"Total Barang: 1", price:"Rp. 23.000"},
    {img:"asset/dashboard/produk/img-12.png", text:"Kitab Riyadush Shalih ...", small:"Total Barang: 2", price:"Rp. 120.000"},
    {img:"asset/dashboard/produk/img-4.png", text:"Kurma Sukaria Al Qosim ...", small:"Total Barang: 1", price:"Rp. 23.000"},
    {img:"asset/dashboard/produk/img-12.png", text:"Kitab Riyadush Shalih ...", small:"Total Barang: 2", price:"Rp. 120.000"},
    {img:"asset/dashboard/produk/img-12.png", text:"Kitab Riyadush Shalih ...", small:"Total Barang: 2", price:"Rp. 120.000"},
    {img:"asset/dashboard/produk/img-12.png", text:"Kitab Riyadush Shalih ...", small:"Total Barang: 2", price:"Rp. 120.000"}
]
